/*
 * Ryan O'Dowd
 * 2022-07-17
 * © Copyright 2022 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */

const getStyles = ({globalScale, colors, isDarkMode, fonts}) => {
  return {
    scrollWrapper: {
      // @TODO: flex: 1,
      minWidth: '100%',
      // @TODO: not working: overflowX: 'auto',
    },
    container: (paginationVisible) =>  {
      const styles: any = {
        borderRadius: globalScale * 8,
        padding: globalScale * 4,
        backgroundColor: colors.primaryLight,
        overflowX: 'auto',
      };

      if (paginationVisible) {
        styles.borderBottomRightRadius = 0;
      }

      return styles;
    },
    row: (index) => {
      const backgroundColors = isDarkMode ? [colors.primaryDark, colors.primaryExtraDark] : [colors.extraLightGray, colors.white];
      return {
        backgroundColor: backgroundColors[index % 2],
        minHeight: 0,
      };
    },
    lastRow: {
      borderBottomLeftRadius: globalScale * 8,
      borderBottomRightRadius: globalScale * 8,
    },
    noBorder: {
      borderWidth: 0,
      paddingRight: 0,
      paddingLeft: 0,
    },
    pagination: {
      color: isDarkMode ? colors.primaryExtraLight : colors.primaryDark,
      fontSize: globalScale * 14,
      backgroundColor: colors.primaryLight,
      borderBottomLeftRadius: globalScale * 8,
      borderBottomRightRadius: globalScale * 8,
      paddingBottom: globalScale * 4,
    },
    paginationText: {
      fontSize: globalScale * 11,
    },
    notVisible: {
      visibility: 'hidden',
      height: 16,
    },
    titleAndSubtitle: (isLightVariant) => {
      return {
        flex: 1,
        flexDirection: 'column',
        color: (isLightVariant && !isDarkMode) ? colors.primaryDark : colors.primaryExtraLight,
      };
    },
    titleText: (isLightVariant) => {
      return {
        fontFamily: fonts.secondaryBold,
        fontSize: globalScale * 16,
        color: (isLightVariant && !isDarkMode) ? colors.primaryDark : colors.primaryExtraLight,
      };
    },
    subtitleText: (isLightVariant) => {
      return {
        fontFamily: fonts.secondary,
        fontSize: globalScale * 14,
        color: (isLightVariant && !isDarkMode) ? colors.accentDark : colors.accent,
      };
    },
    pressableRow: {
      cursor: 'pointer',
    },
    cell: (rightAlign) => {
      return {
        flex: 1,
        width: '100%',
        color: colors.dialogText,
        fontSize: globalScale * 10,
        paddingVertical: globalScale * 6,
        paddingHorizontal: globalScale * 8,
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: rightAlign ? 'flex-end' : 'flex-start',
      };
    },
    cellText: (rightAlign) => {
      return {
        fontSize: globalScale * 10,
        whiteSpace: 'normal',
        textAlign: rightAlign ? 'right' : 'left',
      };
    },

    totalCell: {
      flex: 1,
      borderColor: colors.primary,
      borderTopWidth: 2,
      fontFamily: fonts.primaryBold,
    },
    totalText: {
      color: isDarkMode ? colors.primaryLight : colors.primaryDark,
      fontFamily: fonts.primaryBold,
    },
    filtersWrapper: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    filtersLeft: {
      flexDirection: 'column',
      paddingTop: 12,
    },
  };
};

export default getStyles;
